import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { PublicationHelper } from '../../../../helpers/publication.helper';
import { Member } from '../../../../models/clubs/member.model';
import { LinkifyPipe } from '../../../../pipes/linkify.pipe';
import { MentionMembersPipe } from '../../../../pipes/mention-members.pipe';
import { PublicationService } from '../../../../services/clubs/publication.service';
import { DocumentsService } from '../../../../services/dms/documents.service';
import { ClubsStore } from './../../../../clubs/clubs.store';
import { Publication } from './../../../../models/clubs/publication.model';
import { MemberApiService } from './../../../../services/clubs/member.api.service';
import { ReactionTypeService } from './../../../../services/clubs/reaction-type.service';
import { AccountsService } from './../../../../services/identity/accounts.service';
import { PostsSignalrService } from './../../../../services/signalr/posts-signalr.service';
import { AddNewCommentComponent } from './../add-new-comment/add-new-comment.component';
import { BasePostCardComponent } from './../base-post-card/base-post-card.component';

@Component({
    selector: 'app-comment-card',
    templateUrl: './comment-card.component.html',
    styleUrls: ['./comment-card.component.scss'],

    providers: [MentionMembersPipe, LinkifyPipe],
})
export class CommentCardComponent extends BasePostCardComponent implements OnInit {
    @ViewChild(AddNewCommentComponent) public addNewComment: AddNewCommentComponent;
    public commentsPageSizes = environment.microservices.clubs.settings;
    @Output() public onClickOnAddNewAnswer: EventEmitter<void> = new EventEmitter<void>();
    public shouldShowAddNewComment: boolean;

    constructor(
        protected override accountService: AccountsService,
        protected override memberService: MemberApiService,
        protected override publicationService: PublicationService,
        protected override reactionTypeService: ReactionTypeService,
        override readonly clubsStore: ClubsStore,
        public override readonly publicationHelper: PublicationHelper,
        protected override readonly postsSignalrService: PostsSignalrService,
        protected override readonly documentService: DocumentsService,
        public override sanitizer: DomSanitizer,
        protected override mentionPipe: MentionMembersPipe,

        protected override linkifyPipe: LinkifyPipe,
    ) {
        super(
            accountService,
            memberService,
            publicationService,
            reactionTypeService,
            clubsStore,
            publicationHelper,
            postsSignalrService,
            documentService,
            sanitizer,
            mentionPipe,
            linkifyPipe,
        );
    }

    public enableAndFocusNewCommentComponent(publicationOwner: Member) {
        this.shouldShowAddNewComment = !this.shouldShowAddNewComment;
        if (this.shouldShowAddNewComment) {
            this.areCommentsDisplayed = true;
            const publicationOwnerMember = publicationOwner;
            setTimeout(() => {
                this.addNewComment.setFocusOnNewCommentTextArea(publicationOwnerMember);
            }, 250);
        }
    }

    public override onAddNewComment(newComment: Publication) {
        super.onAddNewComment(newComment);
        //Add this test to be sure that the newComment is written by the current user and not an other one (so a comment received thanks to realtime)
        if (newComment.userId == this.accountService.currentUser.userId) this.shouldShowAddNewComment = false;
        this.areCommentsDisplayed = true;
    }

    public onClickOnAddNewAnswerFunction(publicationOnwer: Member) {
        this.enableAndFocusNewCommentComponent(publicationOnwer);
    }

    public showAddNewComment() {
        if (this.publicationHelper.isPublicationMaxDepth(this.publication)) {
            this.onClickOnAddNewAnswer.emit();
        } else {
            this.enableAndFocusNewCommentComponent(this.publication.owner);
        }
    }
    isContentEmpty(content: string): boolean {
        if (!content) return true;


        const textContent = content
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();

        return textContent.length === 0;
    }
}
